import {
  createCategoryForUrl,
  listingSlug,
  createSlug,
  createSubCategoryForUrl,
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
} from '../../../util/urlHelpers';
import { createResourceLocatorString } from '../../../util/routes';
import { LISTING_STATE_DRAFT, LISTING_STATE_PENDING_APPROVAL } from '../../../util/types';
import { DETAILS, PHOTOS } from '../../EditListingPage/EditListingWizard/EditListingWizardTab';

/**
 * Where "Bekijken als koper" and the card itself point: the public listing page, or
 * its draft/pending-approval preview variant.
 */
export const viewLinkProps = listing => {
  const id = listing.id.uuid;
  const title = listing.attributes.title;
  const slug = createSlug(title);
  const category = createCategoryForUrl(listing.attributes.publicData?.category);
  const type = listing.attributes.publicData?.type;
  const subCategory = createSubCategoryForUrl(listing.attributes.publicData?.category, type);
  const isPendingApproval = listing.attributes.state === LISTING_STATE_PENDING_APPROVAL;
  const isDraft = listing.attributes.state === LISTING_STATE_DRAFT;
  const variant = isDraft
    ? LISTING_PAGE_DRAFT_VARIANT
    : isPendingApproval
    ? LISTING_PAGE_PENDING_APPROVAL_VARIANT
    : null;

  return isPendingApproval || isDraft
    ? {
        name: 'ListingPageVariant',
        params: { id, slug, category, subCategory, variant },
      }
    : {
        name: 'ListingPage',
        params: { slug: listingSlug(listing), category, subCategory },
      };
};

/**
 * Where "Advertentie bewerken" points: the wizard, for every seller.
 *
 * Private sellers used to be sent to `ListingDurationPage` — the pay screen — while
 * only business sellers reached the editor. Under the reordered flow that is simply
 * wrong: payment is a step inside the wizard, and "bewerken" means edit.
 */
export const editLinkProps = (listing, { isDetailsComplete = false } = {}) => {
  const id = listing.id.uuid;
  const title = listing.attributes.title || '';
  const isDraft = listing.attributes.state === LISTING_STATE_DRAFT;

  // Land on the step that still needs something. Sending everyone to details meant a
  // seller who had already filled it in had to work out for themselves that the photos
  // were the missing part, and re-confirm a form they had finished.
  const tab = isDetailsComplete ? PHOTOS : DETAILS;

  return {
    name: 'EditListingPage',
    params: {
      id,
      slug: createSlug(title),
      type: isDraft ? LISTING_PAGE_PARAM_TYPE_DRAFT : LISTING_PAGE_PARAM_TYPE_EDIT,
      tab,
    },
  };
};

export const createListingURL = (routes, listing) => {
  const linkProps = viewLinkProps(listing);
  return createResourceLocatorString(linkProps.name, routes, linkProps.params, {});
};
